export default __webpack_public_path__ + "static/media/Spring21_02.cc3b0b7b.png";